export default function (r: number, g: number, b: number): string {
    const xR = r.toString(16);
    const xG = g.toString(16);
    const xB = b.toString(16);

    return '#' + (xR.length > 1 ? xR : '0' + xR) + (xG.length > 1 ? xG : '0' + xG) + (xB.length > 1 ? xB : '0' + xB);
}
